export default __webpack_public_path__ + "static/media/dismiss-keyboard-error-text.78323ebe.gif";